<mat-form-field class="v2" [ngClass]="wrapperClass" appearance="outline">
	<input
		matInput
		[ngClass]="inputClass"
		[formControl]="control"
		[placeholder]="placeholder"
		[type]="type"
		[readonly]="isReadonly"
		[maxlength]="maxLength"
		[pattern]="pattern"
		[prefix]="prefix"
		[mask]="mask"
		(focus)="onFocus()"
		#inputField
	/>

	<!-- Hint -->
	<mat-hint class="text-small-12px-regular" *ngIf="hint">
		<mat-icon>info</mat-icon>
		{{ hint }}
	</mat-hint>

	<!-- Icons -->
	<mat-icon matPrefix *ngIf="iconPrefix" [svgIcon]="iconPrefix" (click)="onPrefixClick()">{{ iconPrefix }}</mat-icon>
	<mat-icon matSuffix *ngIf="iconSuffix" [svgIcon]="iconSuffix" (click)="onSuffixClick()">{{ iconSuffix }}</mat-icon>

	<!-- Error -->
	<mat-error *ngIf="control.hasError" class="text-small-12px-regular">
		<mat-icon>info</mat-icon>

		{{ errorMessage ? errorMessage : (control.errors | formErrorMessage) }}
	</mat-error>
</mat-form-field>
